function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.733 3.187c.173.101.323.237.441.398l.082.125L29.99 25.54a1.455 1.455 0 01-1.102 2.18l-.154.007H3.266a1.455 1.455 0 01-1.327-2.05l.07-.137L14.745 3.71a1.455 1.455 0 011.989-.523zM16 21.455a1.212 1.212 0 100 2.424 1.212 1.212 0 000-2.424zM16.727 11h-1.454v8h1.454v-8z"
});

function SvgStatusWarning(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    preserveAspectRatio: "xMidYMid",
    fill: "currentcolor",
    "data-qa": "svg",
    "aria-labelledby": titleId
  }, props), title ? React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

export default SvgStatusWarning;